const Appuser = () =>
    import('@/module/index/layout/Appuser.vue')
const info = () =>
    import('@/module/index/pages/userCenter/info.vue')
const center = () =>
    import('@/module/index/pages/userCenter/center.vue')
const security = () =>
    import('@/module/index/pages/userCenter/security.vue')
const evlaLetter = () =>
    import('@/module/index/pages/userCenter/evlaLetter.vue')
// const faceApi = () =>
//     import('@/module/index/pages/userCenter/face-api.vue')
export default {
  path: '/userCenter/center',
  component: Appuser,
  redirect: '/userCenter/center/third',
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  },
  children: [{
    path: '/userCenter/info', // 我的资料
    name: 'info',
    component: info
  },
    //   {
    //     path: '/userCenter/faceApi', // 人脸识别
    //     name: 'faceApi',
    //     component: faceApi
    //   },
  {
    path: '/userCenter/center/:id', // 个人中心
    name: 'center',
    component: center
  },
  {
    path: '/userCenter/security', // 安全设置
    name: 'security',
    component: security
  },
  {
    path: '/userCenter/evlaLetter', // 查看我的评价
    name: 'evlaLetter',
    component: evlaLetter
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/userCenter.js